/**
 * Constants module for the Content Creation application.
 *
 * This module contains all application-wide constants, configuration values,
 * and magic numbers that are used throughout the content creation system.
 */

const CONSTANTS = {
  ONSITE_WORKSHOP: "Onsite Workshop",
  FINAL_TEST: "Final Test",
  INTERNSHIP: "Internship",
  MCQ: "MCQ",
  CODING: "Coding",
  COMPLETED: "Completed",
  RESUME: "Resume",
  START: "Start",
  STARTED: "Started",
  PENDING: "Pending",
  FESTIVALS: "Festivals",
  PREPARATION_DAY: "Preparation Day",
  SEMESTER_EXAM: "Semester Exam",
  INTERNALS: "Internals",
  WEEKLY_TEST: "Weekly Test",
  NOT_STARTED: "Not Started",
  NO_DATE_SET: "No Date Set",
  INVALID_DATE: "Invalid Date",
  TEST_STATUS_SCHEDULED: "Scheduled",
  TEST_STATUS_LIVE: "Live",
  TEST_STATUS_NOT_STARTED: "Not Started",

  // Subject Names
  PYTHON: "Python",
  DSA: "DSA",
  SQL: "SQL",
  HTML: "HTML",
  CSS: "CSS",
  JS: "JS",
  JAVASCRIPT: "JavaScript",

  // Question Selector
  SELECT: "Select",

  // Status Values
  ACTIVE: "active",
  DEFAULT: "default",
  DEFAULT_QN: "defaultQn",

  // Tab Values
  DEFAULT_PREVIEW_TAB: "output",
  UPLOAD_PREVIEW_TAB: "upload",
};

export default CONSTANTS;

export const EditorConstants = {
  PYTHON_CODING: {
    key: "python_coding",
    label: "Python Editor",
  },
  SQL_CODING: {
    key: "sql_coding",
    label: "SQL Editor",
  },
  FRONTEND_CODING: {
    key: "frontend_coding",
    label: "Frontend Editor",
  },
};

/** Normalize API / session editor values to EditorConstants keys. */
export const normalizeEditorKey = (value) => {
  if (value == null || value === "") return "";
  const raw = String(value).trim().toLowerCase();
  const known = Object.values(EditorConstants).map((e) => e.key);
  if (known.includes(raw)) return raw;

  // Common aliases from older payloads / subject-based flows
  if (raw === "python" || raw === "py" || raw === "python editor") {
    return EditorConstants.PYTHON_CODING.key;
  }
  if (raw === "sql" || raw === "sql editor") {
    return EditorConstants.SQL_CODING.key;
  }
  if (
    raw === "frontend" ||
    raw === "html" ||
    raw === "css" ||
    raw === "js" ||
    raw === "javascript" ||
    raw === "frontend editor" ||
    raw === "web"
  ) {
    return EditorConstants.FRONTEND_CODING.key;
  }
  return "";
};

export const ContentTypeConstants = {
  NOTES: {
    key: "notes",
    label: "Notes",
  },
  VIDEO: {
    key: "video",
    label: "Video",
  },
  MCQ: {
    key: "mcq",
    label: "MCQ",
  },
  QUIZ: {
    key: "quiz",
    label: "Quiz",
  },
  CODING: {
    key: "coding",
    label: "Coding",
  },
  PROJECT_CODING: {
    key: "project_coding",
    label: "Project Coding",
  },
};